import ContainerSkeleton from "./ContainerSkeleton"

const EventCardSkeleton = () => {
  return (
    <>
      {Array.from({ length: 6 }, (_, i) => (
        <div key={i} className="flex max-lg:flex-col max-lg:gap-y-4 lg:gap-x-8 mb-12 sm:mb-16 lg:mb-10">
          <div className="w-4/5 lg:w-2/5 h-[230px] sm:h-[300px] lg:h-[330px] rounded-3xl animate-shimmer transition-opacity"></div>
          <div className="relative w-full lg:w-3/5 bg-[rgba(255,255,255,0.7)] rounded-3xl py-4 sm:py-5 px-2 sm:px-4 h-[230px] sm:h-[300px] lg:h-[330px]">
            <div className="px-[18px]">
              <ContainerSkeleton custH="h-5 sm:h-8 xl:h-11" custW="w-full sm:w-[400px] md:w-[450px]" custCls="mb-6 sm:mb-10 xl:mb-11" />
              <ContainerSkeleton custH="h-6 sm:h-9 xl:h-12" custCls="mb-4 sm:mb-5 xl:mb-6" />
              <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5" custCls="mb-1" />
              <ContainerSkeleton custH="h-[14px] sm:h-[18px] xl:h-5" />
            </div>
            <div className="absolute bottom-4 sm:bottom-5 px-[18px] w-3/4">
              <ContainerSkeleton custH="h-[22px] sm:h-[26px] xl:h-7" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default EventCardSkeleton